import { useState } from "react";
import { Button, Snackbar } from "~/common/mui";
import { useTranslation } from "react-i18next";
import { RequestAQuoteDialog, type RequestAQuoteFormData } from "~/domains/configurator/components/dialogs";
import { useCountryOptions } from "~/domains/referenceData/hooks/useFormOptions";
import { useDispatch } from "react-redux";
import { type AppDispatch } from "~/app/store";
import { requestQuoteAction } from "../../redux/actions";
import { type UseFormSetError } from "react-hook-form";
import { ShoppingCartOutlined } from "@mui/icons-material";
import { SnackbarCloseButton } from "~/common/mui/Snackbar/Snackbar";

export interface RequestAQuoteButtonProps {
  termsUrl: string;
  quantity: number;
}

export const RequestAQuoteButton = ({ termsUrl: _termsUrl, quantity }: RequestAQuoteButtonProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const countryOptions = useCountryOptions();
  const [open, setOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = async (
    data: RequestAQuoteFormData,
    helpers: {
      setError: UseFormSetError<RequestAQuoteFormData>;
      onClose: () => void;
    },
  ) => {
    try {
      await dispatch(requestQuoteAction({ ...data, quantity })).unwrap();
      setSnackbarOpen(true);
      helpers.onClose();
    } catch (error) {
      helpers.setError("root", { message: t("feature.configurator.requestQuote.submit.error") });
      console.error("Failed to request quote", error);
    }
  };

  const close = () => setSnackbarOpen(false);

  return (
    <>
      <Button variant="contained" onClick={handleOpen} startIcon={<ShoppingCartOutlined />}>
        {t("feature.configurator.requestQuote.btn.open")}
      </Button>
      <RequestAQuoteDialog open={open} onClose={handleClose} onSubmit={handleSubmit} countryOptions={countryOptions} />
      <Snackbar
        message={t("feature.configurator.requestQuote.submit.success")}
        open={snackbarOpen}
        onClose={close}
        action={<SnackbarCloseButton onClick={close} />}
      />
    </>
  );
};
